var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',_vm._b({},'v-layout',_vm.$attrs,false),[_c('transition',{attrs:{"name":"pop-in"}},[(_vm.isLoaded && !_vm.exiting && !_vm.isThereRequiredProps)?_vm._t("default",null,null,{..._vm.dialogData, isLoaded: _vm.isLoaded}):_vm._e()],2),(!_vm.isLoaded || _vm.isThereRequiredProps)?_c('VcLoader',{staticClass:"loader"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }